import { render, staticRenderFns } from "./userlanding.vue?vue&type=template&id=22977e3e&scoped=true&"
import script from "./userlanding.vue?vue&type=script&lang=js&"
export * from "./userlanding.vue?vue&type=script&lang=js&"
import style0 from "./userlanding.vue?vue&type=style&index=0&id=22977e3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22977e3e",
  null
  
)

export default component.exports